// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2NpOH","choiceBoxes":"toolbarselects_choiceBoxes__3X4ja","simpleField":"toolbarselects_simpleField__9igcU"};